import { useLayoutEffect } from "react";

export const useIncreasedTableWidth = (tableClassName, height = 700) => {
  useLayoutEffect(() => {
    const table = document.querySelector(tableClassName);

    const revenueTableHeight = table.scrollHeight;

    // third operand is used to avoid adding offset on MacOs, as it has option to show scrollbar only when scrolling.
    // It means scrollbar width doest effect table width.
    if (
      revenueTableHeight &&
      revenueTableHeight > height &&
      table.offsetWidth !== table.clientWidth
    ) {
      table.style.width = table.offsetWidth + 8 + "px";
    }
  }, []);
};
